import template from './loansDetailPrepayments.html';
import controller from './loansDetailPrepayments.controller';
import './loansDetailPrepayments.scss';

let loansDetailPrepaymentsComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default loansDetailPrepaymentsComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailPrepayments/loansDetailPrepayments.component.js